export default (customerProductName: string) => {
  const isDevelopment = process.env.NODE_ENV === 'development' || window.location.hostname.endsWith('.test')
  const isStaging = !isDevelopment && (
    window.location.hostname.indexOf('staging.infowijs.nl') > -1
  )

  if (!customerProductName) {
    throw new Error('Please pass a customer product name string')
  }

  if (isStaging) {
    return `https://${customerProductName}.staging.brugger.nl`
  }

  const tld = process.env.INFOWIJS_TLD || (isDevelopment && 'test') || 'nl'
  return `https://${customerProductName}.brugger.${tld}`
}
